import { Operator } from '../../../../../../../services/common/Constants';
import React from 'react';
import ComparisonValue from './ComparisonValue';
import BetweenValue from './BetweenValue';
import NullValue from './NullValue';
import SetValue from './SetValue';


const DateCriterionValue = ({selectedOperator, fieldName, showLabel, readOnly = false}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
    case Operator.GREATER_THAN:
    case Operator.GREATER_OR_EQUAL:
    case Operator.LESS_THAN:
    case Operator.LESS_OR_EQUAL:
      return <ComparisonValue
        selectedOperator={selectedOperator}
        fieldName={fieldName}
        showLabel={showLabel}
        readOnly={readOnly}
      />;
    case Operator.BETWEEN:
      return <BetweenValue/>;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <NullValue/>
    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return <SetValue/>;
    default:
      return (<></>);
  }
}

export default DateCriterionValue;